import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const MenuOptionsContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 21px;
  font-size: 16px;
`;

const MenuText = styled(NavLink)`
  color: #fff;
  text-decoration: none;
  margin-bottom: 10px;
  user-select: none;
  opacity: 0.7;

  &:visited {
    color: #fff;
  }
`;

export { MenuOptionsContainer, MenuText };
